
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { REGIONS_WITH_POSTAL_CODES_BE, REGIONS_WITH_POSTAL_CODES_NL } from '../helpers/constants'
import { IContactPerson, IPostalCodeRange, Regions } from './../types/contact'


@Component({})
export default class ContactPersonSearch extends Vue {
  @Prop({ default: false }) showBelgianMap: boolean
  @Prop() contactPersons: IContactPerson[]
  @Prop() contactPersonSearchNoResultsText: string

  postalCodeSearch: number | null = null

  clickedRegion: Regions | null = null

  Regions = Regions

  get regionsWithPostalCode(): { [key in Regions]?: IPostalCodeRange[] } {
    return this.showBelgianMap ? REGIONS_WITH_POSTAL_CODES_BE : REGIONS_WITH_POSTAL_CODES_NL
  }

  get isValidPostalCode(): boolean {
    return !!this.postalCodeSearch && typeof this.postalCodeSearch == 'number'
      && this.postalCodeSearch >= 1000 && this.postalCodeSearch <= 9999
  }

  get showPostalCodeError(): boolean {
    return !!this.postalCodeSearch && this.postalCodeSearch.toString().length >= 4 && !this.isValidPostalCode
  }

  get searchedRegion(): Regions | null {
    if (!this.isValidPostalCode && !this.clickedRegion) return null

    if (this.clickedRegion) return this.clickedRegion

    const region = Object.keys(this.regionsWithPostalCode).find((region) => {
      const postalCodeRanges = this.regionsWithPostalCode[region as Regions] as IPostalCodeRange[]
      return postalCodeRanges.some(range => this.postalCodeSearch! >= range.from && this.postalCodeSearch! <= range.to)
    })

    return region as Regions || null
  }

  get filteredContactPersons(): IContactPerson[] {
    if (!this.searchedRegion) return []
    return this.contactPersons.filter(contactPerson => contactPerson.regions.includes(this.searchedRegion!))
  }

  get contactPersonsAmountPerRegion(): { [key in Regions]?: number } {
    const amountsPerRegion: { [key in Regions]?: number } = {}
    Object.keys(this.regionsWithPostalCode).forEach(region => {
      const _region = region as Regions
      amountsPerRegion[_region] = this.contactPersons
        .filter(contactPerson => contactPerson.regions.includes(_region))
        .length
    })
    return amountsPerRegion
  }

  clearSearch(): void {
    this.postalCodeSearch = null
  }

  selectRegion(region: Regions) {
    this.postalCodeSearch = null
    this.clickedRegion = region
  }

  @Watch('isValidPostalCode')
  onIsValidPostalCodeChange() {
    if (this.isValidPostalCode) this.clickedRegion = null
  }
}
